import ChecklistItemsInput from '@/ui/components/createEditTaskSidebar/components/ChecklistItemsInput';
import { CheckListValues } from '@/ui/components/createEditTaskSidebar/types';
import { Field, RawInput } from '@payaca/ambrosia';

import { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

export type { CheckListValues };

const ChecklistTaskFieldset: FC = () => {
  /**
   * react hook form
   */
  const { control, register } = useFormContext<CheckListValues>();

  const { fields, append, remove } = useFieldArray({
    name: 'checklistItems',
    control,
    shouldUnregister: true,
  });

  return (
    <>
      <Field name="name">
        <Field.Label>Task name</Field.Label>

        <RawInput
          {...register('name', {
            shouldUnregister: true,
          })}
        />
      </Field>

      <Field name="checklistItems">
        <Field.Label>Checklist</Field.Label>

        <ChecklistItemsInput
          options={fields}
          onAppend={() => {
            append({
              label: '',
            });
          }}
          onRemove={remove}
        />
      </Field>
    </>
  );
};

export default ChecklistTaskFieldset;
